import { AgGridReact } from 'ag-grid-react';

import { WithLocalStorage } from '@/components';
import { useDefaultGridOptions } from '@/grid';
import { defaultColDef } from '@/grid/defaults';

import { useAspirationHistoryColDefs } from '../utils/columnDefs';

type Props = {
  mode?: string;
  rowData: any[] | null;
};

export const AspirationHistoryGrid = ({ mode, rowData }: Props) => {
  const defaultGridOptions = useDefaultGridOptions();
  const aspirationHistoryColDefs = useAspirationHistoryColDefs();
  return (
    <div className="aspiration__aspiration-history-grid">
      <WithLocalStorage storageKey="aspiration__aspiration-history-grid">
        <AgGridReact
          gridOptions={defaultGridOptions}
          className={`ag-theme-transova${mode === 'dark' ? '-dark' : ''}`}
          rowData={rowData || null}
          defaultColDef={defaultColDef}
          columnDefs={aspirationHistoryColDefs}
          rowSelection="single"
        />
      </WithLocalStorage>
    </div>
  );
};
